import styled from 'styled-components'

export const Main = styled.main`
	grid-area: main;
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0 auto;
	gap: 24px;
	position: relative;
	min-width: 0;

	@media only screen and (max-width: 999px) {
		grid-template-columns: 1fr;
	}
`
